import { OrgType } from 'src/@types/org';

export const getDataSourceLabel = (org?: OrgType) => {
  if (!org) return 'RNC Reg ID';
  if (org.managed_by_datatrust) return 'DT Reg ID';
  if (org.data_source === 'l2') return 'LALVOTERID';
  return 'RNC Reg ID';
};
